import React from 'react'
import { useState, useRef } from 'react';
import axios from 'axios';

const ContactComponant = () => {
	const[name, setName] = useState('');
	const[tel, setTel] = useState('');
	const[email, setEmail] = useState('');
	const[message, setMessage] = useState('');
	
	
	const nameRef = useRef();
	const emailRef = useRef();
	const telRef = useRef();
	const messageRef = useRef();


	const sendData = (e) =>{
		console.log(name)
		console.log(tel)
		console.log(email)
		console.log(message)
		
		e.preventDefault();
		var reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
		if(name === ''){
			alert("You didn't enter Full Name.")
			nameRef.current.focus();
			return false;
		}
		else if (tel === "") {
			alert("You didn't enter a phone number.");
			telRef.current.focus();
			return false;
		}
		else if (isNaN(tel)) {
			alert("The phone number contains illegal characters.");
			telRef.current.select();
			return false;
		}
		else if ((tel.length > 10)) {
			alert("The phone number should 10 digits");
			telRef.current.select();
			return false;
		}
		else if ((tel.length < 10)) {
			alert("The phone number should 10 digits");
			telRef.current.select();
			return false;
		}
		else if (email === ''){
			alert("You didn't enter a Email");
			emailRef.current.focus();
			return false;
		}
		else if(!reg.test(email)){
			alert("Invalid Email ID");
			emailRef.current.select();
			return false;
		}
		else if (message === "") {
			alert("Write Your Query");
			messageRef.current.focus();
			return false;
		}
		else{
			axios.post('url',{
				FullName: name,
				phoneNo: tel,
				email: email,
				message: message,
			},
			{
				headers : {"Content-Type": "application/json"}
				
			}).then((response)=>{
				console.log(response)
			}).then((error)=>{
				console.log(error)
			})
		}
	}
  return (
    <React.Fragment>
    <section id="c-ContactUs" className="c-sectionHero">
		<div className="container  pb-0">
			<div className="row">
				<div className="col-md-6 col-sm-12 c-heroContentCol">
					<div className="c-heroContent">
						<h5 className="c-heading46Bold">Start your future today. Get a free consultation.</h5>
						<p className="c-para22Regular">If you have any enquiry, please do not hesitate to contact us. Leave us a message, and we will get back to you shortly.</p>
					
					
					<div>
					<div className="row"> 
					<div className="col-md-12 col-sm-12">
                    <div className="office_main">
					<div className="add_left_mg"><img src="./images/team/address.png" /></div>
					<div className="office_right_cont"><h3>Office Address</h3>
					<p>Finayo,  India Accelerator | Lower Ground Floor, MGF Metropolis Mall, Mehrauli-Gurgaon Rd, Sector 28, Gurugram, Haryana - 122008</p>
					</div>
					</div>
					</div>
					
					<div className="col-md-6 col-sm-12">					
				    <div className="office_main">
					<div className="number_left_mg"><img src="./images/team/contact.png" /></div>
					<div className="office_right_contact"><h3>Phone Number</h3>
					<p>011-12346789, 89</p>
					</div>
					</div>
					
					</div>
					<div className="col-md-6 col-sm-12">
                    <div className="office_main">
					<div className="support_left_mg"><img src="./images/team/support.png" /></div>
					<div className="office_right_contact"><h3>24/7 Support</h3>
					<p>support@finayo.tech</p>
					</div>
					</div>

					</div>
					<div className="col-md-6 col-sm-12">					
				    <div className="office_main">
					<div className="sales_left_mg"><img src="./images/team/sales.png" /></div>
					<div className="office_right_contact"><h3>Sales Team</h3>
					<p>sales@finayo.tech</p>
					</div>
					</div>
					
					</div>
					<div className="col-md-6 col-sm-12">
                    <div className="office_main">
					<div className="career_left_mg"><img src="./images/team/career.png" /></div>
					<div className="office_right_contact"><h3>Career </h3>
					<p>careers@finayo.tech</p>
					</div>
					</div>
					</div>
					</div>
					</div>
					</div>
				</div>
				<div className="col-md-6 col-sm-12 c-heroContentCol">
				<div className="right_form contact">			
				<div className="contact-form">
                            <h3>Let Us Contact You</h3>
                            <form>
							    <label>Full Name</label>
                                <input type="text" placeholder="Your name"
								  onChange={(e)=>{setName(e.target.value)}}
								/>
								<label>Phone Number</label>
                                <input type="email" placeholder="Your Phone No"
								  onChange={(e)=>{setTel(e.target.value)}}
								/>
								<label>Email Address</label>
								<input type="email" placeholder="Your Email"
								   onChange={(e)=>{setEmail(e.target.value)}}
								/>
									 
								<label>Message or Query</label> 
                                <textarea placeholder="Your Message" 
								  onChange={(e)=>{setMessage(e.target.value)}}
								></textarea>
                                <button onClick={sendData}>Submit</button>
                            </form>
                        </div>
			
			</div>
				</div>
			
			</div>
		</div>
	</section>

<section className="ble_sectoion">

	<div className="container">	
		<div className="col-lg-12 col-md-12 col-sm-12 text-center">
		<div className="map_loc">Get the map direction through given <br />below link</div>
		<div className="direct_btn">
		<div className="btn_map">Start Direction</div>
		
		</div>
		</div>
	</div>

</section>
    </React.Fragment>
  )
}

export default ContactComponant